import { BodyText } from '@/components/BodyText';
import { Box, Collapse, ListItemButton, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ExpandMore } from '@mui/icons-material';

const ExpandableItemContainer = styled(Box)({
  position: 'relative',
});

const StyledListItemButton = styled(ListItemButton)({
  padding: '4px 0',
  borderRadius: '4px',
  alignItems: 'flex-start',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent',
    '& .MuiListItemText-primary': {
      textDecoration: 'underline',
      textDecorationColor: 'inherit',
    },
  },
});

const IconContainer = styled(Box)<{ isOpen: boolean }>(({ isOpen }) => ({
  width: '18px',
  height: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '2px',
  marginRight: '8px',
  flexShrink: 0,
  color: 'text.secondary',
  transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
  transition: 'transform 150ms ease-in-out',
}));

const StyledExpandMore = styled(ExpandMore)({
  fontSize: '18px',
});

const StyledListItemText = styled(ListItemText)({
  margin: 0,
});

const VerticalLine = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: '8px',
  top: '26px',
  bottom: 0,
  width: '1px',
  backgroundColor: theme.palette.divider,
  pointerEvents: 'none',
}));

const DescriptionContainer = styled(Box)(({ theme }) => ({
  padding: '8px 16px 16px 24px',
  color: theme.palette.text.secondary,
}));

const TitleText = styled(BodyText)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const ExpandableItem = ({
  title,
  description,
  isOpen,
  onToggle,
}: {
  title: React.ReactNode;
  description: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}) => {
  return (
    <ExpandableItemContainer>
      <StyledListItemButton onClick={onToggle} dense disableGutters disableRipple>
        <IconContainer isOpen={isOpen}>
          <StyledExpandMore />
        </IconContainer>
        <StyledListItemText primary={<TitleText>{title}</TitleText>} />
      </StyledListItemButton>
      {isOpen && <VerticalLine />}
      <Collapse in={isOpen} timeout='auto' unmountOnExit>
        <DescriptionContainer>{description}</DescriptionContainer>
      </Collapse>
    </ExpandableItemContainer>
  );
};
